import { CompanyUser } from '@/api';
import { createContext } from 'react';

export interface MemberContextData {
    companyUser: CompanyUser;
}
export const MemberContext = createContext<MemberContextData | undefined>(
    undefined
);
